import httpService from "./httpService";
import Trade from "../models/trade";

const apiEndpoint = "/trades";

const getTrades = () => {
  return httpService.get<Trade[]>(`${apiEndpoint}/getTrades`);
};

const getTradeById = (idTrade: number) => {
  return httpService.get<Trade>(
    `${apiEndpoint}/getTradeById?idTrade=${idTrade}`
  );
};

const createTrade = (trade: Trade) => {
  return httpService.post<Trade>(`${apiEndpoint}/createTrade`, trade);
};

const updateTrade = (trade: Trade) => {
  return httpService.post<Trade>(`${apiEndpoint}/updateTrade`, trade);
};

const deleteTrade = (trade: Trade) => {
  return httpService.delete<Trade>(`${apiEndpoint}/deleteTrade`, {
    data: trade,
  });
};

const tradeService = {
  getTrades,
  updateTrade,
  deleteTrade,
  createTrade,
  getTradeById,
};

export default tradeService;
